import BaseType from "./BaseType";
import Maths3 from "oc-threejs/Maths3";
import {v3} from "oc-threejs/short3";
import Helper from "../model/Helper";

export default class Fach extends BaseType(THREE.Group) {

    constructor(vsData) {
        super(vsData);
        this.tapable = true;

        this.tapBox = new THREE.Mesh(
            new THREE.BoxGeometry(1, 1, 1),
            new THREE.MeshBasicMaterial({color: 0xff00ff, opacity: 0.5, transparent: true, visible: false}));
        this.add(this.tapBox);
        this.visible = false;
    }

    vsUpdate() {
        this.position.copy(this.vsData.box.getCenter());
        this.quaternion.copy(Maths3.quaternion.zero);
        if (this.isVsChanged('size')) {
            const size = this.vsData.size.clone().sub(v3(0,0,3));
            this.tapBox.scale.copy(size);
        }
    }

    onTap() {
        APP.uiHandler.sidebar("elemente", this.vsData.parent);
        // const size = this.vsData.size;
        // APP.uiHandler.dialog({
        //     title: I18N('dialogShelfHeader'),
        //     text: I18N('dialogShelfText', Helper.formatNum(size.x), Helper.formatNum(size.y), Helper.formatNum(size.z)),
        //     buttons: [
        //         {
        //             style: 'primary',
        //             label: I18N('OK'),
        //             click: input => {
        //             }
        //         }
        //     ]
        // });
    }

}
